import { Fragment } from 'react';
import useToastHandler from '../hooks/useToastHandler';
import { IToast } from '../util/DataModelInterface';
import { Toast } from 'react-bootstrap';
import { useIntl } from 'react-intl';


export const ToastNotifications  = () => {
  const intl = useIntl();
  const {toasts, removeToast} = useToastHandler();

  const getToastItem = (toast: IToast, ind: number) => {
    return (
        <Fragment key={ind}>
            <Toast className={"toast " + toast.type} onClose={() => removeToast(toast)}>
                <Toast.Header className="toast-header" closeLabel={intl.formatMessage({id: 'button.close'})}>
                    <i className="fa fa-warning me-2"></i>
                    <strong className="me-auto">
                    {toast.title}
                    </strong>
                </Toast.Header>
                {toast.content &&
                <Toast.Body className="toast-body">
                    {toast.content}
                    <pre><code>
                        Time: {toast.id}
                        <br/>
                        { JSON.stringify(toast.info, null, "\t")}
                    </code></pre>
                </Toast.Body>
                }
            </Toast>
        </Fragment>
    );
  }

  return (
    <div className="toast-wrap" aria-live="assertive" aria-atomic="true">
        <div className="container">
            {toasts && toasts.length > 0 && toasts.map((toast: IToast, ind: number) =>
                getToastItem(toast, ind)
            )}
        </div>
    </div>
  );
}
